import {useEnv} from '~/helpers/env';

const {apiEndpointUrl} = useEnv();

export const useApiFetch = (options = {}) => {
  return $fetch.create({
    baseURL: apiEndpointUrl,
    headers: {
      Accept: 'application/json',
    },
    ...options,
  });
};
